<template>
  <div id="index">
    <navigation></navigation>
    <div id="big-banner" v-bind:style="{ height: loadHeight + 'px' }">
      <div class="banner-logo">
        <img
          class="logo-c"
          src="../assets/imgs/logo.png"
          alt="Yangyu/洋宇集团"
        />
        <div class="slogen">引领时尚科技 成就不凡未来</div>
      </div>
    </div>

    <div class="group_summary">
      <div class="container">
        <div class="group_summary_container">
          <div class="summary-title">
            <img src="../assets/imgs/about.png" alt="" />
          </div>
          <div class="summary-content">
            <div class="sub-title group-title">
              集团介绍
              <div class="line"></div>
            </div>
            <div class="summary-text">
              洋宇集团以自营品牌为主，集皮鞋、皮具、儿童用品的设计、开发、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发和设计，致力于打造引领时尚和科技的一流产品。在全球时尚中心如法国巴黎、意大利米兰设有时尚信息中心。公司在温州、上海、广州、成都分别设有研发机构。
            </div>
            <div class="more">
              <a href="/#/home"><img src="../assets/imgs/more.png" /></a>
            </div>
          </div>
          <div class="summary-img">
            <img src="../assets/imgs/b1.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="products">
      <div class="container">
        <div class="products_container">
          <div class="products_title">
            <div class="sub-title">
              产品展示<span class="sub-title-en">&nbsp;&nbsp;Products</span>
            </div>
          </div>
          <div class="collect">
            <div
              class="one"
              v-for="n in collects"
              @mouseenter="collectIn()"
              @mouseleave="collectOut()"
              :key="n.title"
            >
              <a href="javascript:void(0);">
                <img :src="n.img" alt="" />
                <div class="content">
                  <div class="c-title">{{ n.title }}</div>
                  <div class="c-summary">{{ n.summary }}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="news">
      <div class="container">
        <div class="news_container">
          <div class="news-title">
            <div class="sub-title">
              集团新闻
              <span class="sub-title-en">News</span>
            </div>
            <div class="more">
              <a href="/#/news">
                <img src="../assets/imgs/more.png" alt="" />
              </a>
            </div>
          </div>
          <div class="news-list">
            <div class="news-list-container">
              <template v-for="(item, index) in newslist">
                <div class="main-news" :key="item.id" v-if="index == 0">
                  <a :href="'/#/detail/' + item.id">
                    <div class="show-img">
                      <img :src="item.image" alt="" />
                    </div>
                    <div class="show-detail">
                      <div class="date">
                        <div class="year">{{ item.year }}</div>
                        <div class="month">{{ item.day }}</div>
                      </div>
                      <div class="content">
                        <div class="news-content-title">
                          {{ item.newsname }}
                        </div>
                        <div class="news-summary">
                          {{ item.summary }}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </template>
              <div class="sub-list">
                <template v-for="(item, index) in newslist">
                  <div class="one" :key="item.id" v-if="index > 0">
                    <a :href="'/#/detail/' + item.id">
                      <div class="sub-list-container">
                        <div class="sub-list-flex">
                          <div class="date">
                            <div class="year">{{ item.year }}</div>
                            <div class="month">{{ item.day }}</div>
                          </div>
                          <div class="content">
                            <div class="news-content-title">
                              {{ item.newsname }}
                            </div>
                            <div class="news-summary">
                              {{ item.summary }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";

export default {
  name: "index",
  components: {
    navigation,
    vfooter: vfooter,
  },
  metaInfo: {
    title: "洋宇集团有限公司",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
      {
        name: "baidu-site-verification",
        content: "code-oGz1N34ih0",
      },
      {
        name: "keywords",
        content: "洋宇集团有限公司,洋宇集团,皮鞋,男士皮鞋,男鞋,男装,拼多多",
      },
      {
        name: "description",
        content: "洋宇集团以自营品牌为主，集皮鞋、皮具、儿童用品的设计、开发、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发和设计，致力于打造引领时尚和科技的一流产品。在全球时尚中心如法国巴黎、意大利米兰设有时尚信息中心。公司在温州、上海、广州、成都分别设有研发机构。",
      },
    ],
  },
  data() {
    return {
      loadHeight: 800,
      showCollectsDetailIndex: -1, //记录鼠标移入的Collect Index，显示detail
      collects: [
        {
          title: "商务休闲",
          summary: "2020秋 男士商务出行复古工装鞋",
          detail:
            "采用先进工艺，将商务风发挥到极致。同时为舒适型提供保障，享受一天的工作。",
          img: require("../assets/imgs/b2.jpg"),
        },
        {
          title: "洋宇定制",
          summary: "定制系列，每一双都是独一无二",
          detail:
            "洋宇集团匠人定制系列，每一双鞋都秉承洋宇文化，在细节处彰显设计，拥有独一无二私人定制。",
          img: require("../assets/imgs/b3.jpg"),
        },
        {
          title: "正装系列",
          summary: "与正装最完美的搭配",
          detail: "将鞋与正装完美的搭配，展现最精细的设计与最完美的匹配。",
          img: require("../assets/imgs/b4.jpg"),
        },
      ],
      newslist: [],
    };
  },
  mounted() {
    this.justifyImgHeight();
    window.onresize = () => {
      this.justifyImgHeight();
    };
    this.getData();
  },
  methods: {
    justifyImgHeight() {
      this.loadHeight = document.body.clientWidth / 2.4;
    },
    collectIn(item) {},
    collectOut(item) {},
    getData() {
      this.axios
        .get("/api/news/list?limit=5")
        .then((res) => {
          this.newslist = res.data.data;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#index {
  width: 100%;
  min-height: 100%;
}

#big-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 800px;
  background-image: url("../assets/imgs/banner1.jpg");
  background-size: 100% 100%;
}

#big-banner .banner-logo {
  width: 554px;
  height: 97px;
}

#big-banner .banner-logo .logo-c {
  width: 531px;
  height: 47px;
}
#big-banner .banner-logo .slogen {
  height: 28px;
  margin-top: 22px;
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
}

.group_summary {
  width: 100%;
  height: 554px;
  background-color: #f3f3f3;
}

.group_summary .group_summary_container {
  display: flex;
  justify-content: space-between;
  padding: 58px 0 26px 0;
}

.group_summary .summary-title {
  width: 60px;
  height: 470px;
}

.group_summary .summary-text {
  margin-top: 35px;
}

.group_summary .more {
  margin-top: 48px;
}

.group_summary .group-title .line {
  width: 32px;
  height: 2px;
  background-color: #ff0000;
  margin-top: 11px;
}

.group_summary .summary-title a {
  width: 100%;
  height: 100%;
}

.group_summary .summary-content {
  width: 552px;
  padding: 79px 0 100px 0;
}

.group_summary .summary-img {
  margin-top: 65px;
}

.products_container {
  padding: 75px 0;
}

.products .products_title {
  display: flex;
  justify-content: space-between;
}

.products .collect {
  display: flex;
  justify-content: space-between;
  margin-top: 54px;
}

.products .collect .one {
  position: relative;
  width: 380px;
  height: 374px;
}

.products .collect .one:hover {
  box-shadow: 0px 1px 23px 4px rgba(153, 153, 153, 0.25);
}

.products .collect .one .content {
  position: absolute;
  bottom: 0;
  width: 376px;
  background-color: white;
  padding: 29px 0 36px 0;
  border: 2px solid #eeeeee;
  border-top: none;
  text-align: center;
}
.products .collect .one .content .c-title {
  font-size: 22px;
  color: #333;
  font-weight: 600;
}

.products .collect .one .content .c-summary {
  font-size: 16px;
  color: #666;
  font-weight: 400;
  margin-top: 13px;
  padding: 0 35px;
}
.news .news_container {
  padding-bottom: 103px;
}
.news .news-title {
  padding: 35px 0;
  display: flex;
  justify-content: space-between;
}

.news .news-list-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 414px;
}

.news .main-news {
  width: 650px;
  height: 414px;
}

.news .main-news a {
  display: block;
  height: 100%;
  width: 100%;
  color: black;

  background: #f7f7f7;
}

.news .main-news .show-img {
  width: 613px;
  height: 300px;
  padding: 19px 19px 0 19px;
}
.news .main-news .show-img img {
  width: 613px;
  height: 300px;
}
.news .main-news .show-detail {
  display: flex;
  /* justify-content: space-between; */
  padding: 24px 23px 0 23px;
}

.news .main-news .show-detail .date {
  width: 49px;
}

.news .main-news .show-detail .date .year {
  font-size: 28px;
  font-weight: bold;

  font-family: Arial Narrow;
  color: #333333;
  border-bottom: 1px solid #333333;
}

.news .main-news .show-detail .date .month {
  width: 100%;
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  color: #666666;
}

.news .main-news .content {
  margin-left: 35px;
}

.news .main-news .content .news-content-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}
.news .main-news .content .news-summary {
  height: 30px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
}

.news .sub-list {
  width: 520px;
  height: 414px;
}

.news .sub-list .one {
  width: 520px;
  height: 90px;
  margin-bottom: 18px;
}

.news .sub-list .one a {
  display: block;
  width: 100%;
  height: 100%;
  background: #f7f7f7;
}

.news .sub-list .one .sub-list-container {
  padding: 18px 31px 27px 19px;
}

.news .sub-list .one .sub-list-flex {
  display: flex;
  justify-content: space-between;
}

.news .sub-list .one .date {
  width: 49px;
}

.news .sub-list .one .date .year {
  font-size: 28px;
  font-weight: bold;
  font-family: Arial Narrow;
  color: #333333;
  border-bottom: 1px solid #333333;
}

.news .sub-list .one .date .month {
  width: 100%;
  text-align: center;

  font-size: 17px;
  font-weight: 400;
  color: #666666;
}

.news .sub-list .one .content {
  margin-left: 35px;
}

.news .sub-list .one .news-content-title {
  font-size: 18px;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  color: #333333;
}
.news .sub-list .one .news-summary {
  height: 30px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
}

.news .sub-list a:hover,
.news .main-news a:hover {
  background: #d91414;
}

.news .sub-list a:hover .date .year,
.news .sub-list a:hover .date .month,
.news .sub-list a:hover .news-content-title,
.news .sub-list a:hover .news-summary {
  color: #f7f7f7;
}

.news .sub-list a:hover .date .year {
  color: #f7f7f7;
  border-bottom: 1px solid #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/page/Index.vue